import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Order } from '@dazzle/api-client';

import { formatPrice, getStatusColor, getStatusLabel } from 'Compass/utils/orderUtils';
import RelativeTime from 'Compass/components/styled/RelativeTime';
import {
  CardLabel,
  CardRow, CardValue,
  Cell,
  DesktopRow,
  MobileCard,
  ProductTitle,
  StatusBadge,
  UserId
} from 'Compass/components/orders/CommonRow';
import { CardBody, CardHeader } from 'react-bootstrap';

const OrderRow = ({ order }: { order: Order }) => {
  const navigate = useNavigate();

  const title = order.product_description.split(' ').slice(0, 5).join (' ');

  return <>
    <DesktopRow onClick={() => navigate(`/order/${order.order_id}`)} role="listitem">
      <Cell>
        <ProductTitle>{order.product_name || title}</ProductTitle>
      </Cell>
      <Cell $alignRight={true}>{formatPrice(order.final_price)}</Cell>
      <Cell>
        <UserId>{order.user_id}</UserId>
      </Cell>
      <Cell>
        <StatusBadge $color={getStatusColor(order.status)}>
          {getStatusLabel(order.status)}
        </StatusBadge>
      </Cell>
      <Cell $highlight={!order.assigned_to}>{order.assigned_to || 'Unassigned'}</Cell>
      <Cell><RelativeTime date={order.last_updated_ts} /></Cell>
    </DesktopRow>
    <MobileCard onClick={() => navigate(`/order/${order.order_id}`)}>
      <CardHeader>
        <ProductTitle>{order.product_name || title}</ProductTitle>
        <StatusBadge $color={getStatusColor(order.status)}>
          {getStatusLabel(order.status)}
        </StatusBadge>
      </CardHeader>
      <CardBody>
        <CardRow>
          <CardLabel>Price</CardLabel>
          <CardValue>{formatPrice(order.final_price)}</CardValue>
        </CardRow>
        <CardRow>
          <CardLabel>User ID</CardLabel>
          <CardValue>
            <UserId>{order.user_id}</UserId>
          </CardValue>
        </CardRow>
        <CardRow>
          <CardLabel>Assigned To</CardLabel>
          <CardValue $highlight={!order.assigned_to}>{order.assigned_to || 'Unassigned'}</CardValue>
        </CardRow>
        <CardRow>
          <CardLabel>Updated</CardLabel>
          <CardValue><RelativeTime date={order.last_updated_ts} /></CardValue>
        </CardRow>
      </CardBody>
    </MobileCard>
  </>;
};

export default OrderRow;
